module.exports = __webpack_public_path__ + "img/ocean_wind.3fa0d94b.svg";